import { render } from "./BuildingTypeCreate.vue?vue&type=template&id=e9da6402&scoped=true"
import script from "./BuildingTypeCreate.vue?vue&type=script&lang=js"
export * from "./BuildingTypeCreate.vue?vue&type=script&lang=js"

import "./BuildingTypeCreate.vue?vue&type=style&index=0&id=e9da6402&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9da6402"]])

export default __exports__